import { render } from "./Slider.vue?vue&type=template&id=60b15878"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=60b15878&lang=scss"
script.render = render

export default script